<template>
    <div>
        <fluke-card>
            <header>
                <div class="title">Adcicionar Aluno</div>
                <div class="description">Insira as informações do aluno</div>
            </header>
            <main>
                <v-text-field label="Nome" v-model="student.name" :disabled="permission.write?null:true"></v-text-field>
                <v-text-field label="Curso" v-model="student.course" :disabled="permission.write?null:true"></v-text-field>
                <v-text-field label="Ano de Conclusão" v-model="student.conclusion_year" :disabled="permission.write?null:true"></v-text-field>
                <v-text-field label="Instrutor" v-model="student.instructor" :disabled="permission.write?null:true"></v-text-field>
                <v-text-field label="Cidade" v-model="student.city" :disabled="permission.write?null:true"></v-text-field>
                <v-text-field label="Estado" v-model="student.state" :disabled="permission.write?null:true"></v-text-field>
            </main>
            <footer v-if="permission.write">
                <fluke-button v-on:click.native="cancel" color="grey">cancelar</fluke-button>
                <fluke-button v-on:click.native="submit">Salvar</fluke-button>
            </footer>
        </fluke-card>
    </div>
</template>

<script>
import axios from 'axios';

import Card from '../../components/Main/Content/Card/Card.vue';
import Button from '../../components/Main/Content/Button/Button.vue';

import permission from '../../mixins/permissions';

export default {
    mixins: [ permission ],
    components: {
        'fluke-card': Card,
        'fluke-button': Button
    },
    data: function() {
        return {
            id: null,
            student: {
                name: '',
                course: '',
                conclusion_year: '',
                instructor: '',
                city: '',
                state: ''
            },
            permission: {
                read: false,
                write: false
            }
        }
    },
    created: function(){
        this.permission = this.getUserPagePermission('students');
		if( this.permission.read == false ) {
			this.$router.push('/');
		}
    },
    methods: {
        submit: async function() {
            const result = await axios.post(
				this.$myServerAddresses.courses + 'students',
				this.student,
                {
                    headers: {
                        'X-Fluke': this.$cookies.get('token')
                    }
                }
            );
            this.$router.push({ name: 'students' });
        },
        cancel() {
            this.$router.push({ name: 'students' });
        }
    }
}
</script>
